module.exports = __webpack_public_path__ + "img/bespoke70_15.4b0d4bf3.jpg";